import * as AdaptiveCards from 'adaptivecards';
import { OpenMailAction } from '../components/OpenMailAction';
import * as MarkdownIt from 'markdown-it';

export const registerCustomAdaptiveCardActions = () => {
    AdaptiveCards.AdaptiveCard.actionTypeRegistry.registerType(
        'Action.OpenMail',
        () => new OpenMailAction()
    );
    AdaptiveCards.AdaptiveCard.onProcessMarkdown = function(
        text: string,
        result: AdaptiveCards.IMarkdownProcessingResult
    ) {
        const markdownRenderOutput = MarkdownIt().render(text);
        result.didProcess = true;
        result.outputHtml = markdownRenderOutput;
    };
};
